var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthiopia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7df4b",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c883a",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92d25",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e44aa",
    d: "M15 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "m15 6.9-.22.7.92 2.83h-1.23l-.14.42h3.94l.58-.42h-2.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "m16.29 10.05 1.62-2.23.17.12-1.62 2.23zm3.55.38h-.72l-2.4 1.75-.39-1.17h-.44l1.21 3.74.58.43-.83-2.58z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "m19.8 13.67-2.61-.85.06-.2 2.63.85zM18 16.12l-.23-.69-2.41-1.75 1-.72-.15-.42-3.18 2.31-.22.69 2.19-1.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "M14.9 14.33h.2v2.76h-.2zM12 16.12l.6-.43.91-2.83 1 .73.36-.27-3.19-2.3h-.72l2.2 1.58z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "m10.2 13.67-.07-.2 2.62-.85.06.2zm-.04-3.24.58.42h2.98l-.38 1.17.36.26 1.22-3.74-.23-.69-.83 2.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/ethiopia.2b53505f04228ae17e0b02a1b825da6f.svg";
export { ForwardRef as ReactComponent };